import { Text, Img } from "components";
import { MyProfile } from "components/MyProfile";


export default function Header1({onMenuClick, ...props }) {
  return (
    <header {...props} className={`${props.className} flex items-center p-2.5 bg-black-900_01`}>
      <base href='/' />
      <div className="mx-auto flex w-full max-w-[1196px] items-center justify-between gap-5 md:flex-col">
        <div className="flex items-center gap-2">
          <button onClick={onMenuClick}>
            <Img  src="images/img_megaphone.svg" alt="Megaphone Icon" className="h-[28px]" />
          </button>          
          <Img src="images/img_header_logo_22x48.png" alt="Header Logo" className="h-[22px] w-[48px] object-contain" />
        </div>
        <div className="flex w-[52%] items-center justify-between gap-5 md:w-full">
          <Img src="images/img_header_logo.svg" alt="Arrowup Logo" className="h-[42px] w-[60px] object-contain" />
          <Text size="textmd" as="p" className="text-[16px] font-medium text-gray-300">
            {<MyProfile />}
          </Text>
        </div>
      </div>
    </header>
  );
}
